const a = (t, n = []) => {
  let e = t;
  return n.forEach((r) => {
    e = e.split(r.name).join(r.value);
  }), e;
};
export {
  a as stringReplacer
};
